import React from 'react';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/style.css';

const fromYMD = (str) => { const [y, m, d] = str.split('-').map(Number); return new Date(y, m - 1, d); };
const toYMD = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

// Calendar where only `allowed` (YYYY-MM-DD) dates can be clicked.
export default function ResumeDatePicker({ allowed, value, onChange, accent = '#f9a826' }) {
  if (!allowed.length) return null;
  const set = new Set(allowed);
  return (
    <div style={{ minWidth: 0, maxWidth: '100%', overflowX: 'auto', '--rdp-accent-color': accent }}>
      <DayPicker
        mode="single"
        selected={value ? fromYMD(value) : undefined}
        onSelect={(date) => onChange(date ? toYMD(date) : '')}
        defaultMonth={fromYMD(allowed[0])}
        startMonth={fromYMD(allowed[0])}
        endMonth={fromYMD(allowed[allowed.length - 1])}
        disabled={(date) => !set.has(toYMD(date))}
      />
    </div>
  );
}
